import type { Components, Theme } from '@mui/material';

export const MuiAccordionSummary: Components<Omit<Theme, 'components'>>['MuiAccordionSummary'] = {
  styleOverrides: {
    root: {
      height: '100px',
      padding: '20px 24px',
      gap: '16px',
      borderRadius: '10px 0px 0px 0px',
      border: '1px solid transparent',
    },
  },
};
